// This file contains all the data the may be modified.
// This data includes gallery images, announcements, and all menu items.

let imageUrlPrefix = 'https://cdn.statically.io/gh/red-rooster-bistro/red-rooster-bistro.github.io/master/assets/'
let staticDir = '/static/'

// Announcements that show up on the home page
let announcements = [
  // {
  //   imageUrl: imageUrlPrefix + 'front.jpg'
  // },
  {
    title: 'Reservations are recommended on weekends.'
  },
  {
    message: ['Serving French-American cuisine in a relaxed country style setting. From simple fare like burgers and salads, to our classic Beef Bourguignon and Steak au Poivre.']
  }
]
export var dataAnnouncements = announcements

// Image name for the gallery page. Image should go in src/assets
let galleryImageUrls = [
  imageUrlPrefix + 'out5.jpg',
  imageUrlPrefix + 'out6.jpg',
  imageUrlPrefix + 'out3.jpg',
  imageUrlPrefix + 'out4.jpg',
  imageUrlPrefix + 'welcome.jpg',
  imageUrlPrefix + 'tap.jpg',
  imageUrlPrefix + 'bar.jpg',
  imageUrlPrefix + 'corner.jpg',
  imageUrlPrefix + 'tables.jpg',
  imageUrlPrefix + 'top.jpg',
  imageUrlPrefix + 'top2.jpg',
  imageUrlPrefix + 'side1.jpg'
]
export var dataGalleryImages = galleryImageUrls

let pdfMenus = [
  {
    svg: staticDir + 'RedRoosterMenu2026-2.svg',
    pdf: staticDir + 'RedRoosterMenu2026-2.pdf',
    alt: 'Red Rooster Full Menu'
  },
  {
    svg: staticDir + 'RedRoosterWine-17.svg',
    pdf: staticDir + 'RedRoosterWine-17.pdf',
    alt: 'Red Rooster Wine Menu'
  }
]
export var dataPdfMenus = pdfMenus

// Menu specials
let specials = [
  // {
  //   name: 'Specials',
  //   desc: 'Call to find out about specials.'
  // }
]
export var dataSpecials = specials

// Starter portion of the menu
let starters = [
  {
    name: 'N.E. Clam Chowder',
    desc: '',
    price: 15
  },
  {
    name: 'Escargot a la Bourguignon',
    desc: 'herbal garlic butter sauce, grilled ciabatta',
    price: 19
  },
  {
    name: 'Grilled Portobello Mushroom',
    desc: 'blue cheese, field greens salad',
    price: 18
  },
  {
    name: 'Chicken Teriyaki Dumplings (fried)',
    desc: '',
    price: 15
  },
  {
    name: 'Pâté de Campagne',
    desc: 'Organic Country Pork Pâté',
    price: 25
  },
  {
    name: 'Fresh Burrata Tomato Caprese',
    desc: 'balsamic glaze',
    price: 18
  },
  {
    name: 'Seafood Cakes',
    desc: 'shrimp, scallops, crabmeat',
    price: 23
  },
  {
    name: 'Greenshell New Zealand Mussels',
    desc: 'saffron cream sauce, baguette toast',
    price: 19
  },
  {
    name: 'Jumbo Shrimp',
    desc: 'sausage, tomatoes, onions, jalapeños, white wine sauce, baguette toast',
    price: 26
  },
  {
    name: 'Red Rooster Salad',
    desc: 'organic field greens, tomatoes, cucumber, red onions, walnuts, goat cheese, raspberry vinaigrette. Add roasted chicken $14; Add jumbo shrimp $16',
    price: 14
  },
  {
    name: 'Shopska Salad',
    desc: 'tomatoes, cucumbers, roasted red peppers, red onions, parsley, shredded feta. Add roasted chicken $14; Add jumbo shrimp $16',
    price: 14
  },
  {
    name: 'Beets Salad',
    desc: 'organic field greens, roasted almonds, orange segment, citrus vinaigrette. Add roasted chicken $14; Add jumbo shrimp $16',
    price: 14
  }
]
export var dataStarters = starters

// Main course portion of the menu
let mainCourses = [
  {
    name: 'Chicken Milanese',
    desc: 'panko pan-fried cutlet, topped with organic field greens, tomatoes, red onion, Bulgarian Feta, house vinaigrette',
    price: 30
  },
  {
    name: 'Chicken Valdostana',
    desc: 'panko pan-fried cutlet, topped with sauteed spinach, melted Fontina, spaghetti garlic and oil',
    price: 35
  },
  {
    name: 'Chicken Cordon Bleu',
    desc: 'panko pan-fried cutlet, layers of pork filet, French brie, smoked gouda, swiss, mushroom sauce, mashed potato & vegetables',
    price: 36
  },
  {
    name: 'Maple leaf farms Duck',
    desc: 'Crispy half Duck, mashed potato & vegetables, unagi demi-glace',
    price: 39
  },
  {
    name: 'Boeuf Bourguignon',
    desc: 'tender pot roast, vegetables & mashed potatoes',
    price: 39
  },
  {
    name: 'Fresh Tagliatelle',
    desc: 'jumbo shrimp, roasted red peppers, spinach, cream sauce',
    price: 38
  },
  {
    name: 'Faroe Islands Salmon',
    desc: 'mashed potatoes, vegetables, beurre blanc sauce',
    price: 36
  },
  {
    name: 'Boneless Ribeye Steak au Poivre',
    desc: 'mashed potatoes, vegetables, green peppercorn sauce',
    price: 64,
    marked: true
  },
  {
    name: 'N.Z. Rack of Lamb',
    desc: 'mashed potatoes, vegetables, demi glace',
    price: 49,
    marked: true
  },
  {
    name: 'Eggplant Rollatini',
    desc: 'ricotta, spinach, melted cheese, tomato sauce, spaghetti',
    price: 28
  },
  {
    name: 'Black Angus Burger',
    desc: 'all burgers served with French fries, lettuce, tomato, raw onion and pickle; add Bacon - $4; Mushrooms, American, Swiss, Habanero Jack, Cheddar, Blue - $3 each',
    price: 22,
    marked: true
  },
  {
    name: 'Penne ala Vodka',
    desc: 'With Chicken $28; With Shrimp $36',
    price: 26
  },
  {
    name: 'Spaghetti Bolognese',
    desc: 'black Angus meat sauce',
    price: 29
  }
]
export var dataMainCourses = mainCourses

// Dessert portion of the menu
let desserts = [
  {
    name: 'Flourless Chocolate Cake',
    desc: '',
    price: 12
  },
  {
    name: 'Chocolate Bourbon Pecan Pie',
    desc: '',
    price: 12
  },
  {
    name: 'Chocolate Strawberry Crepes',
    desc: '',
    price: 12
  },
  {
    name: 'Vanilla & Chocolate Ice Cream Tartufo',
    desc: '',
    price: 12
  },
  {
    name: 'Crème Brûlée',
    desc: '',
    price: 12
  },
  {
    name: 'Vanilla Ice Cream',
    desc: '',
    price: 8
  }
]
export var dataDesserts = desserts

// Cocktail portion of the menu
let drinks = [
]
export var dataDrinks = drinks

// White wine portion of the menu
let wineListWhite = [
  {
    type: 'wine',
    name: 'Bedell Cellars Pinot Gris',
    location: 'Long Island, NY',
    desc: 'Pears, tart apples, crisp refreshing, saline minerality hand harvested whole cluster pressed',
    price: 16,
    bottlePrice: 50
  },
  {
    type: 'wine',
    name: 'Sannino Fresco, White Wine Blend',
    location: 'Long Island, NY',
    desc: 'This is a light, bright and refreshing crisp white wine. The nose offers a bright bouquet of white blossoms and zippy lime zest on the palate. A field blend of eight unique white varieties from our youngest vines.',
    price: 16,
    bottlePrice: 50
  },
  {
    type: 'wine',
    name: 'Sannino Chilly Day Chardonnay 2023',
    location: 'Long Island, NY',
    desc: 'Dry and unoaked Chardoannay. An all time Sannino favorite, sure to brighten up the chilliest days.',
    bottlePrice: 50
  },
  {
    type: 'wine',
    name: 'Paloma de Plata Albariño 2021',
    location: 'Rias Baixas, Spain',
    desc: 'On the palate notes of peach and apricot emerge with a beautiful minerality on the finish. Great acidity throughout keeps thi s wine light on its feet and deliciously-easy to drink.',
    bottlePrice: 56
  },
  {
    type: 'wine',
    name: 'Deux Roches Tradition Saint-Véran 2022 White',
    location: 'Burgundy, France',
    desc: 'Dressed in liquid gold, this cuvée gives off a floral scent reminiscent of honeysuckle and acacia flowers. Once in the mouth, the juice reveals itself to be both firm and fat, the attack is round, delicately structured and mineral. The lingering finish is carried by gentle citrusy bitters.',
    bottlePrice: 56
  },
  {
    type: 'wine',
    name: 'Nicolas Idiart Sauvignon Blanc',
    location: 'Loire Valley, France',
    desc: 'This intensely aromatic, 100% Sauvignon Blanc, is easy to drink. It boasts notes of citrus and grapefruit with mint and peach flavors. Crisp finish.',
    bottlePrice: 48
  },
  {
    type: 'wine',
    name: 'Maison Idiart Joie de Vivre Rosé',
    location: 'France',
    desc: 'REGION: Southwest/France VARIETALS: Grenache, Cinsault & Syrah NOTES: Elegant profile of lemons & strawberries on the nose. Medium-bodied & soft on the palate w/ a hint of red fruits. Good structure w/ a refreshing finish.',
    bottlePrice: 48
  }
]
export var dataWineListWhite = wineListWhite

// Red wine portion of the menu
let wineListRed = [
  {
    type: 'wine',
    name: 'Sannino Spotlight Pepit Verdot',
    location: 'Long Island, NY',
    desc: 'Beautiful dark purple in color, this wine is 100% Petit Verdot. Rich and full-bodied.',
    price: 16,
    bottlePrice: 50
  },
  {
    type: 'wine',
    name: 'Bedell Malbec',
    location: 'Long Island, NY',
    desc: 'Sultry dark fruit, exotic+enticing, supple + ripe oak aged hand harvested.',
    price: 16,
    bottlePrice: 50
  },
  {
    type: 'wine',
    name: 'McCall Cabernet Franc',
    location: 'Long Island, NY',
    desc: 'Deep dark fruit with undertones of cassis and baking spice. 34 year old vines show a lush terroir with spicy green and black pepper on the finish.',
    price: 16,
    bottlePrice: 50
  },
  {
    type: 'wine',
    name: 'Isla Grand Reserve Côtes du Rhône AOC',
    location: 'France',
    desc: '60% Grenache, 40% Syrah offers flavors of spice, dark fruit and amazing velvety tannins.',
    bottlePrice: 56
  },
  {
    type: 'wine',
    name: 'Condado de Oriza Reserva 2020',
    location: 'Pagos del Rey, Ribera del Duero, Spain',
    desc: '100% Tempranillo grape blend. Dark cherry red color, deep and bright. Hints of fruit and elegant notes of fine wood. Velvety body in the mouth, with a pleasant aftertaste.',
    bottlePrice: 54
  },
  {
    type: 'wine',
    name: 'A La Carte Pinot Noir',
    location: 'North Coast, California',
    desc: 'Deep ruby red tone draws you into its dark cherry, cola and subtle mint aromatics, flavors of red huckleberry, orange zest and bergamot linger on the long finish.',
    bottlePrice: 52
  },
  {
    type: 'wine',
    name: 'Glassblower Cabernet Sauvignon 2023',
    location: 'Napa Valley , California',
    desc: 'This classic Cabernet Sauvignon is bold and structured. Aromas of deep black fruit lead to flavors of juicy plum, blackberry and baking spice. This wine is full-bodied and excellently balanced, its finish persistent and elegant',
    bottlePrice: 60
  },
  {
    type: 'wine',
    name: 'Château Haut Peyrat 2019',
    location: 'Cadillac Côtes de Bordeaux, France',
    desc: '65% Merlot, 18% Cabernet Sauvignon, 17% Cabernet Franc Ripe and juicy, this wine offers spice with underlying firm tannins. Its structure is dense, with concentration and a lifted layer of acidity.Quickly feel the blackcurrant and blackberry notes, mixing we can elegantly with the pastry perfume of the French oak.',
    bottlePrice: 80
  },
  {
    type: 'wine',
    name: 'Pierre Troupel 2020',
    location: 'Chateauneuf-du-Pape, France',
    desc: 'Aromas of ripe juicy cherries, rhubarb and mint leaves gently rolled in dusty sun-scorched earth welcome the nose. The palate is prominently dark fruited, with black peppercorn that persists through the midpalate, leading to a dried tarragon and granitic finish.',
    bottlePrice: 120
  }
]
export var dataWineListRed = wineListRed

// Sparkling wine portion of the menu
let wineListSparkling = [
  {
    type: 'wine',
    name: 'Ca’ Del Doge Prosecco Rosé, D.O.C. (750ml)',
    location: 'Italy',
    desc: 'Made with 85 to 90% Glera, 10 to 15% Pinot Nero vinified in red, fine and elegant. Fruity and floral notes, soft, bright pink, pleasant presence of foam',
    bottlePrice: 48
  },
  {
    type: 'wine',
    name: 'Trevisana Prosecco (200ml)',
    location: 'Italy',
    desc: 'Orchard fruits, crisp pears, and lemon curd, all of which come together in a rich, creamy off-dry style that is extremely appealing.',
    bottlePrice: 14
  }
]
export var dataWineListSparkling = wineListSparkling



// WEBPACK FOOTER //
// ./src/data.js